import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";
import React, { memo } from "react";

const LanguageIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 25 24"
      sx={{ fontSize: "inherit", ...sx }}
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.625 1.5C9.03921 1.5 9.375 1.83579 9.375 2.25V4.125H15.75C16.1642 4.125 16.5 4.46079 16.5 4.875C16.5 5.28921 16.1642 5.625 15.75 5.625H13.6838C13.1194 7.38107 11.8888 10.1032 9.86902 12.8222C10.6076 13.6009 11.4676 14.3943 12.4573 15.1555C12.7856 15.4081 12.847 15.879 12.5945 16.2073C12.3419 16.5356 11.871 16.597 11.5427 16.3445C10.5567 15.586 9.68855 14.7955 8.93167 14.0121C7.53539 15.6835 5.82916 17.2993 3.78374 18.6288C3.43645 18.8546 2.97191 18.756 2.74617 18.4087C2.52043 18.0614 2.61896 17.5969 2.96626 17.3712C4.9407 16.0878 6.58098 14.5124 7.91414 12.8887C6.22977 10.9032 5.26931 9.09148 4.92015 8.13131C4.7786 7.74203 4.97942 7.31171 5.36869 7.17015C5.75797 7.0286 6.18829 7.22942 6.32985 7.61869C6.60407 8.3728 7.4102 9.91991 8.85219 11.6721C10.4829 9.41973 11.5419 7.19079 12.1002 5.625H1.5C1.08579 5.625 0.75 5.28921 0.75 4.875C0.75 4.46079 1.08579 4.125 1.5 4.125H7.875V2.25C7.875 1.83579 8.21079 1.5 8.625 1.5ZM17.2393 9.37508C17.5421 9.37078 17.8178 9.54896 17.9382 9.82679L22.8132 21.0768C22.9779 21.4569 22.8033 21.8985 22.4232 22.0632C22.0431 22.2279 21.6015 22.0533 21.4368 21.6732L20.1701 18.75H14.6078L13.4464 21.6535C13.2925 22.0381 12.856 22.2252 12.4715 22.0714C12.0869 21.9175 11.8998 21.481 12.0536 21.0965L16.5536 9.84646C16.6661 9.56532 16.9366 9.37938 17.2393 9.37508ZM15.2078 17.25H19.5201L17.2777 12.0752L15.2078 17.25Z"
        fill="#243648"
        stroke="#243648"
        strokeWidth="0.075"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default memo(LanguageIcon);
